import styled from 'styled-components';

export const CardHeader = styled.div`
    width: 100%;
    background: #fff;
    border-radius: 5px;
    padding: 10px 30px;
    margin-bottom: 30px;
    box-shadow: 0 4px 8px 0 rgba(43, 53, 86, 0.05);
`;

export const PageHeader = styled.div`
    height: 70px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    > div {
        flex: 1;
        text-align: center;

        &:first-child {
            text-align: left;
        }

        &:last-child {
            text-align: right;
        }
    }
`;

export const ActionButtons = styled.div`
    padding-top: 15px;
    border-top: 1px solid var(--color-border-500);
`;

export const TemplateCardBody = styled.div`
    h4 {
        text-align: center;
    }
`;

export const Fullwidth = styled.div`
    background: #fff;
    margin-bottom: 40px;
    border-bottom: 1px solid var(--color-border-500);
`;
